/**
 * Created by vladislav on 7/14/2025
 */

const MultiBots = function () {
    connector.player.on("changed", this._post.bind(this));
};

MultiBots.prototype.get = function (amount, callback) {
    const path = `${connector.config.multiApiURL}/bots?amount=${amount}`;

    ConnectorRestClient.get(path, {}, callback, () => {
        callback();
    });
};

MultiBots.prototype._post = function () {
    const name = connector.player.name;
    const avatar = connector.player.avatar;

    if (name && avatar) {
        ConnectorRestClient.post(`${connector.config.multiApiURL}/bots`, {
            id: connector.platform.getUserID(),
            name: name.slice(0, 50),
            avatar
        }, () => {}, () => {});
    }
};